import React from 'react';
import Features from '../FeatureSelection/container/Features'

export default [
    {
        path: '/features',
        exact: true,
        component: () => <Features />
    },
];